import styled from "styled-components";

export const RadioWrapper = styled.div`
  display: flex;
  align-items: center;
  width: max-content;
  cursor: pointer;
  label {
    cursor: pointer;
  }
`;

export const RadioInput = styled.input`
  position: relative;
  width: 12px;
  height: 12px;
  appearance: none;
  ::before {
    content: "";
    opacity: 1;
    position: absolute;
    box-sizing: border-box;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 1px solid ${(p) => p.theme["gray-6"]};
  }
  :checked {
    ::before {
      background-color: #fff;
      border: 3px solid var(--main-color);
    }
  }
`;
